import React from 'react';
import { InputAdornment, IconButton, withStyles, StyledComponentProps, TextField as MuiTextField } from '@material-ui/core';
import { DeleteText as Clear } from '../Icons';
import { styles } from './styles';

interface IProps extends StyledComponentProps {
    label?: string;
    value: number;
    onChange?: (val: number) => any;
    onBlur?: (val: string) => any;
    placeholder?: string;
    disabled?: boolean;
    className?: any;
}
const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
};

const TextField = (props: IProps) => {
    const { classes, value, ...otherProps } = props;
    const { text, label, clearIcon, ...otherClasses } = classes;

    return (
        <MuiTextField
            fullWidth
            type="number"
            color="secondary"
            margin={"normal"}
            value={value || ''}
            {...{ ...otherProps, ...otherClasses }}
            onChange={(e) => props.onChange(e.target.value ? +e.target.value : undefined)}
            onBlur={(e) => props.onBlur && props.onBlur(e.target.value)}
            InputProps={{
                endAdornment: endIcon(props.onChange, props.disabled, clearIcon),
                classes: {

                }
            }}
        />
    );
}
const endIcon = (onChange?: (val: number) => any, disabled?: boolean, clearIconClass?: string) => {
    if (disabled)
        return null;
    return (<InputAdornment position="end" variant='filled'>
        <IconButton
            aria-label="clear"
            onClick={(e) => onChange(undefined)}
            onMouseDown={handleMouseDown}
            disableFocusRipple
            size='small'
            color='secondary'
        >
            <Clear className={clearIconClass} />
        </IconButton>
    </InputAdornment>)
}
export default withStyles(styles)(TextField);